class WbTextBox {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    if (!this.el.classList.contains('wb-text-box--fade')) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.el.classList.add('is-visible');
          observer.unobserve(this.el);
        }
      });
    }, { threshold: 0.1 });

    observer.observe(this.el);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-wb-text-box]').forEach(el => new WbTextBox(el));
});